import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  IconButton
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import {postDeleteApplications} from '../../../../utils/requests';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  content: {
    padding: 0
  },
  image: {

    height: 54,
    width: 64,
    marginRight: 10
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const options = [
  'View Details',
  'Withdraw Application'
];

const Offers = props => {
  const { className, history, data, ...rest } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const [snackErrorOpen, setSnackErrorOpen] = React.useState(false);
  const [snackSuccessOpen, setSnackSuccessOpen] = React.useState(false);
  // const [offer, setOffer] = React.useState([]);

  const checkOffer = (offer) => {
    // console.log(offer)
  }
  const handleSnackError = () => {
    setSnackErrorOpen(true);
  };
  const handleSnackSuccess = () => {
    setSnackSuccessOpen(true);
  };

  const handleErrorSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackErrorOpen(false);
  };
  const handleSuccessSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackSuccessOpen(false);
  };


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleOptionClick = (option, offer) => {
    setAnchorEl(null);
    if(option === 0){
      history.push({
        pathname: '/offers/' + offer.hashed_id
      });
    }else if (option === 1){
      return postDeleteApplications(offer.hashed_id)
        .then((res) => {
          // console.log('worked')
          if(res === true){
            handleSnackSuccess();
            refresh();
            }
          else
            handleSnackError();
        })
    }
  };

  const refresh = () => {
    window.location.reload(false);
  }

  // const [products] = useState(mockData);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        subtitle={`${data.length} in total`}
        title="Applications you submitted"
      />
      <Divider />
      <CardContent className={classes.content}>
        <List>
          {data.map((offer, i) => (
            <ListItem
              divider={i < data.length - 1}
              key={offer._id}
            >
              <ListItemAvatar>
                <img
                  alt="Product"
                  className={classes.image}
                  src={(offer.company && offer.company.logo)?offer.company.logo:"https://cdn-pcs.auicareerspark.com/app-assets/app-assets/def-opportunity.jpg"}
                />
              </ListItemAvatar>
              <ListItemText
                primary={offer.title}
                secondary={'Submitted on ' + moment(offer.application.createdAt).format('MMMM Do YYYY, h:mm a')}
              />
              {/* <IconButton
                aria-haspopup="true"
                aria-label="more"
                onClick={handleClick}
                size="small"
              >
                <MoreVertIcon />
              </IconButton> */}
              <Button
                size="small"
                color="primary"
                variant="outlined"
                onClick={() => handleOptionClick(0, offer)}
              >
                  Details
              </Button>
              <Button
                size="small"
                color="#B2DFDB"
                onClick={() => handleOptionClick(1, offer)}
              >
                  Withdraw
              </Button>
            </ListItem>
          ))}
        </List>
      </CardContent>
      <Divider />
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          size="small"
          variant="text"
        >
          View all <ArrowRightIcon />
        </Button>
      </CardActions>

      <Snackbar
        autoHideDuration={6000}
        onClose={handleErrorSnackClose}
        open={snackErrorOpen}
      >
        <Alert
          onClose={handleErrorSnackClose}
          severity="error"
        >
          Unable to delete this offer
        </Alert>
      </Snackbar>
      <Snackbar
        autoHideDuration={6000}
        onClose={handleSuccessSnackClose}
        open={snackSuccessOpen}
      >
        <Alert
          onClose={handleSuccessSnackClose}
          severity="success"
        >
          Offer Deleted Successfully
        </Alert>
      </Snackbar>
    </Card>
  );
};

Offers.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array
};

export default Offers;